//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let token = localStorage.getItem("token-admin")
export default {
  name: "NewDIP",
  data: function() {
    return {
      data: { description: "", legalBase: "" },
      unitOption: [],
      categoryOption: [],
      formatOption: [],
      limitOption: [
        { label: "2 Tahun", value: 2 },
        { label: "5 Tahun", value: 5 },
        { label: "10 Tahun", value: 10 },
        { label: "30 Tahun", value: 30 },
      ],
      statusOption: [
        { label: "Publish", value: "Y" },
        { label: "Unpublish", value: "N" },
      ],
      accept: false,
      unitOption: [],
      id: "",
    };
  },
  mounted() {
    this.fetch();
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.$http
        .get("/info_public_byid/" + this.id, {
          headers: { Authorization: "Bearer " + token}
        })
        .then((result) => {
          this.data = result.data;
        });
    },
    fetch() {
      this.$http
        .get("/category_info", {
          headers: { Authorization: "Bearer " + token}
        })
        .then((result) => {
          for (var i = 0; i < result.data.length; i++) {
            this.categoryOption.push({
              label: result.data[i].name,
              value: result.data[i].id,
            });
          }
        });

      this.$http
        .get("/format_info", {
          headers: { Authorization: "Bearer " + token}
        })
        .then((result) => {
          for (var i = 0; i < result.data.length; i++) {
            this.formatOption.push({
              label: result.data[i].name,
              value: result.data[i].id,
            });
          }
        });
      this.$http.get("/work_unit", {
        headers: { Authorization: "Bearer " + token}
      })
      .then((result) => {
        for (var i = 0; i < result.data.length; i++) {
          this.unitOption.push({
            label: result.data[i].name,
            value: result.data[i].id,
          });
        }
      });
    },
  },
};
